import React from 'react';
import { usePortalShortcutMap } from './portalShortcutContext';
import { portalNavShortcutHint, type PortalShortcutId } from './portalShortcuts';

/** Dezenter Kürzel-Hinweis am bestehenden Knopf. Kein Overlay. Ohne Belegung nichts. */
export const PortalShortcutHint: React.FC<{ id: PortalShortcutId; className?: string }> = ({
  id,
  className = '',
}) => {
  const map = usePortalShortcutMap();
  const label = portalNavShortcutHint(id, map);
  if (!label) return null;
  return (
    <kbd
      className={`portal-nav-shortcut shrink-0 rounded border border-white/[0.1] px-1 py-0 text-[9px] font-medium leading-4 text-slate-500 ${className}`}
      title={label}
    >
      {label}
    </kbd>
  );
};
